import SearchReportText from './SearchReportText';
export default SearchReportText;
